import * as am5 from '@amcharts/amcharts5';

export const mainColorGradation = [
  am5.color('#13345a'),

  am5.color('#1f3f6f'),
  am5.color('#2b5f9d'),
  am5.color('#3d76ba'),
  am5.color('#4788d7'),
  am5.color('#5a98e1'),
  am5.color('#66a5ed'),
  am5.color('#79b2f2'),
  am5.color('#86bef7'),
  am5.color('#8bc6fc'),
  am5.color('#a3d6ff'),

  am5.color('#bcdaff'),

  //색상 reverse
  am5.color('#a3d6ff'),
  am5.color('#8bc6fc'),
  am5.color('#86bef7'),
  am5.color('#79b2f2'),
  am5.color('#66a5ed'),
  am5.color('#5a98e1'),
  am5.color('#4788d7'),
  am5.color('#3d76ba'),
  am5.color('#2b5f9d'),
  am5.color('#1f3f6f'),
]



//////////////////
// WEBPACK FOOTER
// ./config/amChart/_config.js
// module id = null
// module chunks = 